import {
  codesmithDesktopBridge,
  useCodesmithSurface,
} from "@/lib/codesmithSurface";

/** In-place explanation for surfaces that only show [code]smith. */
export function CodesmithDisabledNotice() {
  const desktop =
    useCodesmithSurface(null) === "desktop" ? codesmithDesktopBridge() : null;
  return (
    <div className="flex h-full flex-col items-center justify-center gap-2 p-6 text-center type-body-s-regular text-neutral-500 dark:text-neutral-400">
      [code]smith is not enabled for this organization.
      {desktop && (
        <button
          type="button"
          className="type-body-s-medium text-neutral-900 underline-offset-4 hover:underline dark:text-white"
          onClick={() => desktop.openExternal(window.location.href)}
        >
          Open in browser
        </button>
      )}
    </div>
  );
}
